export const Header = (props) => {
    const {
        screenSize
    } = props;

    return (
        <div className={`app-header ${screenSize === 'small' ? 'small-screen' : ''}`}>
            <div>
            Veteran's Navigator
            </div>
            <div className={`header-description ${screenSize === 'small' ? 'small-screen' : ''}`}>
                Providing resources to veterans and their families
            </div>
        </div>
    )
}